import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
  OnInit,
} from '@angular/core';
import { BinSizeTypes, ChartTypes } from '@mode/shared/contract-common';
import { DropdownItem } from '../dropdown/dropdown-list.component';
import { FormatListItem } from '../format-list-item';
import { getFormatterByType } from '@mode/shared/util-js';

interface TitlePositionDropdownItem extends DropdownItem {
  value: ChartTypes.HeaderAxisLocationTypes;
}
@Component({
  selector: 'mode-format-builder-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, OnChanges {
  @Input() field!: FormatListItem;
  @Input() fieldSuggestedBinInfo?: BinSizeTypes.BinSizeMetaData;
  @Input() headerFormat: ChartTypes.HeaderFieldFormat | undefined;
  @Input() chartType: ChartTypes.ChartType | undefined;
  @Input() isAxis = false;
  @Output() update = new EventEmitter<ChartTypes.HeaderFieldFormat>();

  titleFormat: ChartTypes.TitleFormat | undefined;
  textFormat: ChartTypes.TextFormat | undefined;
  valuesFormat: ChartTypes.ValuesFormat | undefined;
  labelFormat: ChartTypes.LabelFormat | undefined;

  titlePositionMenuItems: Array<TitlePositionDropdownItem> = [
    {
      name: 'Auto',
      value: ChartTypes.HeaderAxisLocationTypes.Auto,
    },
    {
      name: 'Axis',
      value: ChartTypes.HeaderAxisLocationTypes.Axis,
    },
    {
      name: 'Header',
      value: ChartTypes.HeaderAxisLocationTypes.Header,
    },
  ];
  titlePosition = this.titlePositionMenuItems[0];
  titleCheckboxLabel = 'Show title';
  titleInputLabel = 'Title';
  titleLocationLabel = 'Title location';

  updateTitle(title: ChartTypes.TitleFormat) {
    this.titleFormat = { ...title, location: this.titlePosition.value };
    this.update.emit({
      title: this.titleFormat,
    });
  }

  updateDefault(format: ChartTypes.TextFormat) {
    this.update.emit({
      default: format,
    });
  }

  updateRotation(rotation: number) {
    this.labelFormat = { ...(this.labelFormat ?? {}), rotation };
    this.update.emit({
      label: this.labelFormat,
    });
  }

  updateShowValues(values: ChartTypes.ValuesFormat) {
    this.update.emit({
      showValues: values,
    });
  }

  updateBinnedAxisLabels(binnedAxisLabels: ChartTypes.BinnedAxisLabelTypeFormat) {
    this.update.emit({
      binnedAxisLabel: binnedAxisLabels,
    });
  }

  ngOnInit(): void {
    this.initCommon();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.headerFormat) {
      this.titleFormat = this.headerFormat?.title;
      this.textFormat = this.headerFormat?.default;
      this.valuesFormat = this.headerFormat?.showValues;
      this.labelFormat = this.headerFormat?.label;
    }
    this.initCommon();
  }

  initCommon() {
    this.titlePosition =
      this.titlePositionMenuItems.find((t) => t.value === this.headerFormat?.title?.location) ??
      this.titlePositionMenuItems[0];
    this.titleCheckboxLabel = this.isAxis ? 'Show axis title' : 'Show header title';
    this.titleInputLabel = this.isAxis ? 'Axis title' : 'Header title';
    this.titleLocationLabel = this.isAxis ? 'Axis title location' : 'Header title location';
  }

  onTitlePositionChange(item: TitlePositionDropdownItem) {
    this.titlePosition = item;
    this.titleFormat = {
      ...(this.titleFormat ?? {
        text: '',
        show: true,
      }),
      location: this.titlePosition.value,
    };
    this.update.emit({
      title: this.titleFormat,
    });
  }
}
